// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export const WatermarkRendererViewMode =
{
    NONE: 1,
    SYMBOL: 2,
    DESCRIPTION: 3,
    SYMBOLANDDESCRIPTION: 4,
    LOGO: 5
}
Object.freeze(WatermarkRendererViewMode);